import log from '@/utils/consolelog'
import watches from '@/api/modules/watches'
import profile from '@/api/modules/profile'
import files from '@/api/modules/files'
import * as mutations from './mutations'
import generateBase64Picture from '@/utils/generateBase64Picture'

const watchesInitialState = {
	data: [],
	loading: false,
	error: null
}

const profileInitialState = {
	data: null,
	loading: false,
	error: null
}

const pictureInitialState = {
	data: null,
	loading: false,
	error: null
}

export default {
	state: Object.assign({}, watchesInitialState),
	getters: {
		getWatches: state => state.data,
		getWatchesLoading: state => state.loading,
		getWatchesError: state => state.error,
		getWatch: state => id => state.data.find(watch => watch.id == id ),
		getWatchPicture: state => id => {
			const watch = state.data.find(watch => watch.id == id )
			return watch ? watch.picture.data : null
		}
	},
	mutations: {
		// Watches
		[mutations.SET_WATCHES] (state, value) {
			state.data = value
		},
		[mutations.SET_WATCHES_LOADING] (state, value) {
			state.loading = value
		},
		[mutations.SET_WATCHES_ERROR] (state, value) {
			state.error = value
		},
		[mutations.CLEAR_WATCHES] (state) {
			Object.assign(state, watchesInitialState)
		},
		// Profiles
		[mutations.SET_PROFILE] (state, { watch_id, profile }) {
			const watch = state.data.find(watch => watch.id === watch_id)
			if (watch) watch.profile.data = profile
		},
		[mutations.SET_PROFILE_LOADING] (state, { watch_id, loading }) {
			const watch = state.data.find(watch => watch.id === watch_id)
			if (watch) watch.profile.loading = loading
		},
		[mutations.SET_PROFILE_ERROR] (state, { watch_id, error }) {
			const watch = state.data.find(watch => watch.id === watch_id)
			if (watch) watch.profile.error = error
		},
		// Pictures
		[mutations.SET_PICTURE] (state, { watch_id, picture }) {
			const watch = state.data.find(watch => watch.id === watch_id)
			if (watch) watch.picture.data = picture
		},
		[mutations.SET_PICTURE_LOADING] (state, { watch_id, loading }) {
			const watch = state.data.find(watch => watch.id === watch_id)
			if (watch) watch.picture.loading = loading
		},
		[mutations.SET_PICTURE_ERROR] (state, { watch_id, error }) {
			const watch = state.data.find(watch => watch.id === watch_id)
			if (watch) watchpicture.error = error
		}
	},
	actions: {
		setWatches ({ commit }, value) {
			commit(mutations.SET_WATCHES, value)
		},
		setWatchesLoading ({ commit }, value) {
			commit(mutations.SET_WATCHES_LOADING, value)
		},
		setWatchProfile ({ commit }, value) {
			commit(mutations.SET_PROFILE, value)
		},
		getWatches ({ commit, state, dispatch }, { context, user_uid }) {
			//if (!state.loading) {
				commit(mutations.SET_WATCHES_LOADING, true)
				watches.getAll(context, user_uid).then(response => {
					log.log('store', 'watches.getAll OK', response)()
					const watches = response.body.map(watch => {
						watch.user_uid = user_uid
						watch.profile = Object.assign({}, profileInitialState)
						watch.picture_uid = watch.picture
						watch.picture = Object.assign({}, pictureInitialState)
						return watch
					}).sort((a, b) => a.name.localeCompare(b.name))
					commit(mutations.SET_WATCHES, watches)
				}).catch(error => {
					log.error('store', 'watches.getAll ERROR', error)()
					commit(mutations.SET_WATCHES_ERROR, error)
				}).finally(() => {
					commit(mutations.SET_WATCHES_LOADING, false)
					// Get profiles and pictures
					state.data.forEach(watch => {
						dispatch('getWatchProfile', { context, user_uid, watch_id: watch.id })
						if (watch.picture_uid) dispatch('getWatchPicture', { context, user_uid, watch_id: watch.id, file_uid: watch.picture_uid })
					})
				})
			//}
		},
		getWatchProfile ({ commit }, { context, user_uid, watch_id }) {
			commit(mutations.SET_PROFILE_LOADING, { watch_id, loading: true })
			profile.get(context, user_uid, watch_id)
				.then(response => {
					log.log('store', 'profile.get OK', response)()
					commit(mutations.SET_PROFILE, { watch_id, profile: response.body })
				}).catch(error => {
					log.error('store', 'profile.get ERROR', error)()
					commit(mutations.SET_PROFILE_ERROR, { watch_id, error })
				}).finally(() => {
					commit(mutations.SET_PROFILE_LOADING, { watch_id, loading: false })
				})
		},
		getWatchPicture ({ commit }, { context, user_uid, watch_id, file_uid }) {
			commit(mutations.SET_PICTURE_LOADING, { watch_id, loading: true })
			const getPictureData = function (context, user_uid, file_uid) {
				return files.get(context, user_uid, null, file_uid)
					.then(response => {
						log.log('store', 'files.get OK', response)()
						return response.body
					}).catch(error => {
						log.error('store', 'files.get ERROR', error)()
					})
			}
			const getPictureMetadata = function (context, user_uid, file_uid) {
				return files.getMetadata(context, user_uid, null, file_uid)
					.then(response => {
						log.log('store', 'files.getMetadata OK', response)()
						return response.body
					}).catch(error => {
						log.error('store', 'files.getMetadata ERROR', error)()
					})
			}
			Promise.all([getPictureData(context, user_uid, file_uid), getPictureMetadata(context, user_uid, file_uid)])
				.then(([data, metadata]) => {
					log.log('store', 'getPicture() OK', [data, metadata])()
					commit(mutations.SET_PICTURE, { watch_id, picture: generateBase64Picture(data, metadata.extension) })
				}).catch(error => {
					log.error('store', 'getPicture() ERROR', error)()
					commit(mutations.SET_PICTURE_ERROR, { watch_id, error })
				}).finally(() => {
					commit(mutations.SET_PICTURE_LOADING, { watch_id, loading: false })
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/watches.js